// import Vue from "vue";
// export function getComponentHtml(component, props) {
//   // Create a temporary container element
//   const container = document.createElement("div");
//   // Instantiate and mount the component
//   const ComponentConstructor = Vue.extend(component);
//   const instance = new ComponentConstructor({
//     propsData: props,
//     store
//   }).$mount(container);
//   // Extract the rendered HTML
//   const htmlString = instance.$el.outerHTML;
//   // Optionally, destroy the instance
//   instance.$destroy();
//   return htmlString;
// }
import { createApp } from "vue";

import store from "@/vuex/store";

export function getComponentHtml(component, props) {
  // Create a container
  const container = document.createElement("div");

  // Create app instance and pass props via a wrapper
  const app = createApp(component, props);

  // Provide the store if necessary (e.g., Vuex or Pinia)
  app.use(store);

  // Mount the component to the container
  app.mount(container);

  // Get HTML
  const htmlString = container.outerHTML;

  // Clean up
  app.unmount();

  return htmlString;
}
